import { Button, Grid, Typography } from '@mui/material';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { ROUTE_CREATE_LETTER } from '@/app/routes';
import { Theme } from '@mui/material/styles';
import React, { FC, ReactElement } from 'react';

interface Props {
  region?: string;
  department?: string;
  prisonerFirstName?: string;
  prisonerMiddleName?: string;
  prisonerLastName?: string;
  isChanged?: boolean;
  isMobile?: boolean;
}

export const TittleInfo: FC<Props> = (props: Props): ReactElement => {
  const { region, department, prisonerFirstName, prisonerMiddleName, prisonerLastName, isChanged, isMobile } = props;

  const navigate: NavigateFunction = useNavigate();

  return (
    <Grid
      container={true}
      direction={'row'}
      sx={{
        borderRadius: '6px',
        background: (theme: Theme) => theme.colors.grayBackground,
        padding: '16px',
        color: (theme: Theme) => (isChanged ? theme.colors.primary : ''),
      }}>
      <Grid container={true} alignItems={'center'} justifyContent={'space-between'} spacing={isMobile ? 1 : 0}>
        <Grid item={true}>
          <Grid container={true} spacing={isMobile ? 2 : 5}>
            <Grid item={true}>
              <Grid container={true} direction={'column'}>
                <Grid item={true} mb={0.5}>
                  <Typography
                    variant={'label1'}
                    sx={{
                      display: 'block',
                      textTransform: 'uppercase',
                      color: (theme: Theme) => theme.colors.grayText,
                    }}>
                    {'Учреждение'}
                  </Typography>
                </Grid>
                <Grid item={true}>
                  <Typography variant={'h4'} fontWeight={400}>{`${department}, ${region}`}</Typography>
                </Grid>
              </Grid>
            </Grid>
            {prisonerFirstName && prisonerMiddleName && (
              <Grid item={true}>
                <Grid container={true} direction={'column'}>
                  <Grid item={true} mb={0.5}>
                    <Typography
                      variant={'label1'}
                      sx={{
                        display: 'block',
                        textTransform: 'uppercase',
                        color: (theme: Theme) => theme.colors.grayText,
                      }}>
                      {'Адресат'}
                    </Typography>
                  </Grid>
                  <Grid item={true}>
                    <Typography variant={'h4'} fontWeight={400}>
                      {`${prisonerLastName} ${prisonerFirstName} ${prisonerMiddleName}`}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
        {isChanged && (
          <Grid item={true}>
            <Button size={'small'} onClick={(): void | Promise<void> => navigate(ROUTE_CREATE_LETTER)}>
              {'Изменить'}
            </Button>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
